import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Proof } from '@feature/proof';
import { generateProofApi, generateProofOptions } from '@feature/proof/proofGenerator';
import { Id } from '@feature/utils';

const chapterProofApi = generateProofApi('/proof-file/chapter');
const { getProofsOptions, getProofsByOwnerOptions, createOrUpdateProofOptions, deleteProofOptions } =
  generateProofOptions('chapter', chapterProofApi);

export function getChapterProofsByOwnerOptions(chapterId: Id, userId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsByOwnerOptions(chapterId, userId);
}

export function getChapterProofsOptions(chapterId: Id): UseSuspenseQueryOptions<Proof[]> {
  return getProofsOptions(chapterId);
}

export function useUploadOrUpdateChapterProof(chapterId: Id) {
  const queryClient = useQueryClient();
  return useMutation(createOrUpdateProofOptions(chapterId, queryClient));
}

export function useDeleteChapterProof(chapterId: Id) {
  const queryClient = useQueryClient();
  return useMutation(deleteProofOptions(chapterId, queryClient));
}
